const state = {
  userData: {}
}

export default state
